import type { SelectorObject } from '../types';

export const usageProductVariantSummarySelectors = {
  commitmentAmountInput: 'usage-product-variant-summary-commitment-amount-input',
  trashButton: 'usage-product-variant-summary-trash-button',
} satisfies SelectorObject<'usage-product-variant-summary-'>;
